<div (click)="close()" class="button">
    <i class="color-white fa-solid fa-x fa-xl"></i>
</div>
